import React, {useEffect, useRef, useState} from 'react';
import Results from "components/Header/Search/Results";
import ProductService from "services/Product";
import SearchService from "services/Search";
import PubSub from "services/PubSub/";
import TagManagerService from "services/TagManager";
import StorageService from "services/StorageService";
import { withRouter } from "react-router";
import magnifyingGlass from 'images/menu/magnifying-glass.svg';
import { addClass, removeClass, cleanSearch } from 'utils';
import PropTypes from "prop-types";
import style from './style.scss'; //NOSONAR

let searchTime = null;
let initScroll = 0;
let scrollTime = null;
let actions = [];
let isModalAutocomplete = false;

const Search = (props) => {
    const [isLoading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [position, setPosition] = useState(-1);
    const [submitted, setSubmitted] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [historySearch, setHistorySearch] = useState([]);
    const [modalAutocomplete, setModalAutocomplete] = useState(false);
    const [categories, setCategories] = useState([]);
    const [sticky, setSticky] = useState(true);
    const searchInput = useRef(null);

    const getContent = (inputValue) => {
        if(!inputValue) return false;

        Promise.all([
            ProductService.getSearchCategories(inputValue.toLowerCase()),
            SearchService.searchSuggesions(inputValue.toLowerCase())
        ]).then(results => {
            if(!isModalAutocomplete){
                return false
            }

            setCategories(factoryCategories(results[0]));
            setSuggestions((!results[1] || (results[1].status && results[1].status === 403)) ? [] : results[1]);

            isModalAutocomplete =  true;
            setModalAutocomplete(isModalAutocomplete);

            setLoading(false);
            setPosition(-1);

            if(document){
                addClass(document.documentElement, 'non-scroll');
            }
        });
    };

    useEffect(()=> {
        clearTimeout(searchTime);
        searchTime = setTimeout(() => {
            const inputValue = cleanSearch(search);
            if (inputValue.length >= 2) {
                setLoading(true);

                getContent(inputValue);

            } else {
                setLoading(false);
                setCategories([]);
                setSuggestions([]);
            }

        }, 300);
    }, [search]);

    const factoryCategories = (data) => {
        if(!(data  && data.itemsReturned)) return [];
        return data.itemsReturned.filter(item => item.items.length === 0 && item.thumb === '');
    };

    const onChange = (event) => {
        let inputValue = event.target.value;
        setSearch(inputValue);
    };

    const onFocus = () => {
        isModalAutocomplete = true;
        setModalAutocomplete(isModalAutocomplete);
        setSubmitted(false);

        if(document) {
            addClass(document.documentElement, 'non-scroll');
        }

        PubSub.dispatch('toggle_minicart', { state: false });
        PubSub.dispatch('toggle_menu', { state: false });
        PubSub.dispatch('mobile_app');

        TagManagerService.clickHeader('Search', 'Header');

        const _historySearch = JSON.parse(StorageService.getItem('history_search')) || [];
        setHistorySearch(_historySearch);

        if(search){
            getContent(search);
        }
    };

    const closeModalAutocomplete = () => {
        isModalAutocomplete = false;
        setModalAutocomplete(isModalAutocomplete);
        setLoading(false);

        if(document){
            removeClass(document.documentElement, 'non-scroll');
        }

        if(!search){
            setSuggestions([]);
        }

        clearTimeout(searchTime);
    };

    const goBack = (event) => {
        event.preventDefault();
        closeModalAutocomplete();
    };

    const onSubmit = (event, i) => {

        setSubmitted(true);

        let searchQuery = cleanSearch(search.toLowerCase());
        if(event) event.preventDefault();

        const indexPosition = (i || i === 0) ? i : position;

        if(search.length === 0 && indexPosition === -1){
            return false;
        }

        let arrayItems = '';

        if(!search.length) {
            arrayItems = historySearch;
        } else {
            arrayItems = suggestions;
        }

        const suggestionClean = arrayItems[indexPosition] ? cleanSearch(arrayItems[indexPosition]) : search;


        if(indexPosition > -1){
            props.history.push(`/busca?ft=${suggestionClean}`);
            setSearch(suggestionClean);
        } else {
            if(!suggestions.length){
                props.history.push(`/busca?ft=${searchQuery}`);
            } else {
                const suggestionClean = cleanSearch(searchQuery);
                props.history.push(`/busca?ft=${suggestionClean}`);
            }
        }

        saveOnHistory(suggestionClean);
        document.activeElement.blur();
        closeModalAutocomplete();
    };

    const removeHistory = ( i) => {
        const _historySearch = JSON.parse(StorageService.getItem('history_search')) || [];
        _historySearch.splice(i,1);
        StorageService.setItem('history_search', JSON.stringify(_historySearch));
        setHistorySearch(_historySearch);
        getContent();
    }

    const saveOnHistory = (suggestionClean) => {
        const searchQuery = cleanSearch(suggestionClean);
        const _historySearch = JSON.parse(StorageService.getItem('history_search')) || [];
        if (!_historySearch) return false;

        if(search !== ''){
            if(_historySearch.indexOf(searchQuery.toLowerCase()) === -1){
                if(_historySearch.length <= 11){

                    _historySearch.unshift(searchQuery.toLowerCase());
                    StorageService.setItem('history_search', JSON.stringify(_historySearch));

                } else if(_historySearch.length === 12){

                    _historySearch.pop();
                    _historySearch.unshift(searchQuery.toLowerCase());
                    StorageService.setItem('history_search', JSON.stringify(_historySearch));
                }
            } else {
                _historySearch.splice(_historySearch.indexOf(searchQuery));
            }
        }
    };

    const clearSearch = (event) => {
        event.preventDefault();
        setSuggestions([]);
        setHistorySearch([]);
        setSearch('');
        setTimeout(()=>{
            searchInput.current.focus();
        }, 0);
    };

    const scrollVerify = () => {
        clearTimeout(scrollTime);
        scrollTime = setTimeout(() => {
            if(isModalAutocomplete) return false;
            const pos = window.scrollY;
            const isSticky = pos <= initScroll || pos === 0;

            if(isSticky !== sticky){
                setSticky(isSticky);
            }
        }, 0);
    };

    const startScroll = () => {
        initScroll = window.scrollY;
    };

    useEffect(() => {
        actions.push(PubSub.register('product_redirect', closeModalAutocomplete));
        actions.push(PubSub.register('search_redirect', closeModalAutocomplete));
        actions.push(PubSub.register('toggle_search', () => {
            setModalAutocomplete(true);
            setTimeout(() => {
                searchInput.current.focus();

            }, 0);
        }));

        if(!search.length && !historySearch.length){
            setPosition(-1);
        }

        document.addEventListener('keydown', _keyDown);

        return function cleanup(){
            document.removeEventListener('keydown', _keyDown);
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    useEffect(() => {

        if (window) {
            window.addEventListener("touchend", scrollVerify);
            window.addEventListener("touchmove", startScroll);
        }

        return function cleanup(){
            if (window) {
                window.removeEventListener("touchend", scrollVerify);
                window.removeEventListener("touchmove", startScroll);
            }
        }

    }, [sticky]);

    const _keyDown = (data) => {
        let arrayLength = '';

        if(!search.length) {
            arrayLength = historySearch.length;
        } else {
            arrayLength = suggestions.length;
        }

        if(isModalAutocomplete) {
            var pos;

            switch (data.keyCode) {
                case 40:
                    data.preventDefault();
                    pos = position + 1;
                    if(pos > arrayLength) {
                        pos = 0;
                    }
                    setPosition(pos);
                    break;
                case 38:
                    data.preventDefault();
                    pos = position - 1;
                    if(pos < -1) break;
                    setPosition(pos);
                    break;
                case 27:
                    data.preventDefault();
                    document.activeElement.blur();
                    closeModalAutocomplete();
                    break;
            }
        }
    };

    const setSearchItem = (searchItem, i) => {
        setSearch(searchItem.toLowerCase());
        onSubmit(null, i);
    }

    const resultsProps = {
        isLoading,
        search,
        modalAutocomplete,
        categories,
        position,
        suggestions,
        historySearch,
        setSearchItem,
        removeHistory
    };

    return <div className={'new-header-search '+ ((modalAutocomplete && !submitted) ? ' active ' : '') + (sticky ? ' sticky ' : '')}>
        <form className='new-header-search-form' onSubmit={onSubmit}>
            <button className='new-header-back-btn font-icn point-arrow-left' onClick={goBack} type='button' aria-label="close seach button"/>
            <input ref={searchInput} type="text" className='new-header-search-input' placeholder='¿Qué estás buscando?' tabIndex={1} onChange={onChange} onFocus={onFocus} value={search} aria-label="Search Bar"/>
            <button className='new-header-search-submit' type='submit' aria-label="search button"><i className='search-submit-icon' dangerouslySetInnerHTML={{ __html: magnifyingGlass }}></i></button>
            {search && search.length > 0 && modalAutocomplete && <button className='new-header-search-clear-btn' onClick={clearSearch} type='button' aria-label="clear search button"/>}

            {!submitted && <Results {...resultsProps} />}
        </form>

        <div className={'new-header-search-overlay ' + ((modalAutocomplete && !submitted) ? 'active' : '')} onClick={closeModalAutocomplete} />
    </div>;
};

Search.propTypes = {
    history: PropTypes.object
};

export default withRouter(Search);
